// src/data/products.js
export const sampleProducts = [];

export const productReviews = {};

export const getProductsByCategory = (categoryId, subcategoryId = null) => {
  return [];
};

export const getProductsByBrand = (brand) => {
  return [];
};

export const getProductsByTag = (tag) => {
  return [];
};

export const getFeaturedProducts = () => {
  return [];
};

export const getNewProducts = () => {
  return [];
};

export const getDiscountedProducts = () => {
  return [];
};

export const searchProducts = (searchTerm) => {
  return [];
};

export const getProductById = (id) => {
  return null;
};

export const getProductStats = () => {
  return {
    total: 0,
    inStock: 0,
    outOfStock: 0,
    featured: 0,
    discounted: 0,
    byCategory: {}
  };
};

export const categories = [];
